/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { vappContainer } from '@/application';
import { logger as log } from '@common/logger';
import { BuyInsurancePageService } from '@pages/BuyInsurancePage/services';

const MODULE_NAME = 'profile.machines.states.createOrder';

const getSrv = () => {
  return vappContainer.get<BuyInsurancePageService>(
    BuyInsurancePageService.displayName
  );
};

export const createOrder = async (context: any, event: any) => {
  const currentState = 'CREATE_ORDER';
  const method = 'createOrder';

  return new Promise(async (resolve, reject) => {
    try {
      log.log(MODULE_NAME, 'context: ', context, 'event: ', event);
      const srv = getSrv();
      const createOrder = await srv?.agent?.getCreateOrderProps(event?.payload);
      if (createOrder) {
        return resolve({
          key: 'CREATE_ORDER',
          value: {
            ...(createOrder || {}),
          },
        });
      } else {
        const msg = 'Page content not found';
        log.error(MODULE_NAME, `error in ${method}, msg: ${msg}`);
        return reject({
          key: 'CREATE_ORDER',
          value: msg,
        });
      }
    } catch (err: any) {
      log.error(MODULE_NAME, `error in ${method}, msg: ${err?.message}`);
      return reject({
        key: 'CREATE_ORDER',
        value: err?.message,
      });
    }
  });
};
